import styled from 'styled-components';
import { propStyles } from '@kurtosys/ksys-portal-components/build/utils/propStyles';
import { verticalAlign } from '../utils/customPropStyles';

export const Table = styled<any, any>('table')`
    ${propStyles};
    table-layout: fixed;
    width: 100%;
    border-collapse: collapse;
`;

export const TableHead = styled<any, any>('thead')`
    ${propStyles};
`;

export const TableBody = styled<any, any>('tbody')`
    ${propStyles};
`;

export const TableRow = styled<any, any>('tr')`
    ${propStyles};
`;

export const ColumnHeader = styled<any, any>('th')`
    ${propStyles};
    ${verticalAlign};
`;

ColumnHeader.defaultProps = {
    paddingX: "sm",
    paddingY: "md",
    minWidth: "10%",
    color: "inherit",
    fontSize: "sm",
    fontFamily: "heading",
    fontWeight: "medium",
    textAlign: "left",
    verticalAlign: "top",
    borderWidth: "2px",
    borderColor: "gray500",
    borderStyle: "none none solid none"
};

export const SubColumnHeader = ColumnHeader.extend`
`;

SubColumnHeader.defaultProps = {
    fontSize: "xs",
    fontFamily: "body",
    fontWeight: "regular"
};

export const ColumnGroup = styled<any, any>('div')`
    ${propStyles};
`;

ColumnGroup.defaultProps = {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    height: "100%"
};

export const ColumnGroupLabel = styled<any, any>('div')`
    ${propStyles};
`;

ColumnGroupLabel.defaultProps = {
    fontFamily: "heading",
    fontWeight: "normal",
    margin: "0 0 0.5em 0",
    padding: "0 0 0.5em 0",
    borderWidth: "1px",
    borderStyle: "none none solid none",
    borderColor: "gray500"
};


// WEBPACK FOOTER //
// ./src/Components/Grid.tsx